export default class User {
  createdAt;
  department;
  email;
  firstName;
  fullNameUppercase;
  function;
  group;
  id;
  isADAccountEnabled;
  isOnCall;
  lastBatchId;
  locationCountry;
  locationOffice;
  novatedProjectCode;
  payglobalUserId;
  payglobalUsername;
  phoneNumber;
  plannedTerminationDate;
  positionTitle;
  reportingManagerPayglobalUsername;
  startDate;
  surname;
  team;
  teamMemberLevel;
  updatedAt;
  userPrincipalName;
  visaCode;
  visaEffectEndDate;
  visaEffectStartDate;

  hasFullAccess() {
    /** Matches kiln-backend `EMPLOYEE_SERVICE_DEPARTMENTS` (PayGlobal strings, compared uppercase). */
    const EMPLOYEE_SERVICE_DEPARTMENTS = ["PEOPLE CONSULTING"];
    const PEP_TEAM = ["PEOPLE EXPERIENCE PLATFORMS"];
    const EXCEPTION_LIST_UPN = ["DEAN.NOVELLY@MYOB.COM", "MARTIN.LONGLEY@MYOB.COM"];

    /** returns true if
     * user department is People Consulting (PC), or
     * user team is People Experience Platforms (PEP), or
     * user UPN includes exception list EXCEPTION_LIST_UPN, or
     * user position title is HEAD OF DIGITAL EXPERIENCE
     */
    return (
      EMPLOYEE_SERVICE_DEPARTMENTS.includes(String(this?.department || "").toUpperCase()) ||
      PEP_TEAM.includes(String(this?.team || "").toUpperCase()) ||
      EXCEPTION_LIST_UPN.includes(String(this?.userPrincipalName || "").toUpperCase()) ||
      String(this?.positionTitle || "").toUpperCase() === "HEAD OF DIGITAL EXPERIENCE"
    );
  }

  hasOnboardingEmployeeServicesAccess() {
    const ONBOARDING_EXCEPTION_LIST_UPN = [
      "LAUREN.FORBES@MYOB.COM",
      "ASHLEIGH.LYAS@MYOB.COM",
      "EMILY.WULF@MYOB.COM",
      "ADAM.AVCI@MYOB.COM",
      "CAROLINE.DONOVAN@MYOB.COM",
      "TROY.SAUNDERCOCK@MYOB.COM",
      "SUJITHA.RAMESH@MYOB.COM",
      "PRIYA.SATISH@MYOB.COM",
    ];

    return (
      this.hasFullAccess() ||
      ONBOARDING_EXCEPTION_LIST_UPN.includes(String(this?.userPrincipalName || "").toUpperCase())
    );
  }
}
